import { render, staticRenderFns } from "./AutocompleteQuestion.vue?vue&type=template&id=2e8a19c1&"
import script from "./AutocompleteQuestion.vue?vue&type=script&lang=js&"
export * from "./AutocompleteQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports